var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38496 17.4485C14.0326 17.4485 18.2168 11.1109 18.2168 5.61667C18.2168 5.43851 18.2128 5.25638 18.2049 5.07821C19.0188 4.48959 19.7212 3.76049 20.2791 2.92518C19.5211 3.26244 18.7162 3.48271 17.8921 3.57845C18.7599 3.0583 19.4096 2.24117 19.7209 1.27853C18.9045 1.76233 18.0118 2.10361 17.0809 2.28774C16.4536 1.62128 15.6243 1.18 14.7211 1.03214C13.818 0.884269 12.8912 1.03805 12.0842 1.4697C11.2772 1.90135 10.6349 2.58682 10.2565 3.42015C9.87817 4.25347 9.78486 5.18823 9.99104 6.0799C8.33805 5.99695 6.72094 5.56755 5.24455 4.81953C3.76816 4.07152 2.46545 3.02158 1.42087 1.7378C0.889952 2.65316 0.727492 3.73632 0.966503 4.76716C1.20551 5.79799 1.82806 6.69915 2.70762 7.28747C2.0473 7.26651 1.40145 7.08872 0.823416 6.76881V6.82028C0.822825 7.78088 1.15491 8.71204 1.76323 9.45547C2.37155 10.1989 3.21856 10.7087 4.16027 10.8983C3.54858 11.0657 2.9066 11.09 2.28398 10.9696C2.54971 11.7957 3.06673 12.5182 3.76288 13.0364C4.45903 13.5545 5.29957 13.8424 6.16721 13.8598C4.69422 15.0169 2.87466 15.6444 1.00158 15.6415C0.669407 15.641 0.337558 15.6206 0.0078125 15.5805C1.91066 16.8013 4.12418 17.4496 6.38496 17.4485Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.da13a294e35b75eb175afe10fbb2d311.svg";
export { ForwardRef as ReactComponent };